import { isClient } from "@/lib/common";

export const copyTextToClipboard = (text: string) => {
    try {
        navigator.clipboard.writeText(text);
        return true;
    } catch {
        console.error("Failed to copy content");
    }
    return false;
};

export const shareToNativeApi = (title: string, text: string, url: string) => {
    if (window.nativeIntegration?.share) {
        window.nativeIntegration.share(title, text, url);
        return true;
    }

    const { webkit } = window as any;
    if (webkit?.messageHandlers?.share?.postMessage) {
        webkit.messageHandlers.share.postMessage({
            title,
            text,
            url,
        });
        return true;
    }

    return false;
};

export const gotoNativeScreen = (relativePath: string) => {
    const {
        webkit,
        nativeIntegration,
        location: { origin },
    } = window;
    const { href } = new URL(relativePath, origin);

    if (nativeIntegration?.goToScreen) {
        return nativeIntegration.goToScreen(href);
    }

    if (webkit?.messageHandlers?.goToScreen?.postMessage) {
        return webkit.messageHandlers.goToScreen.postMessage(href);
    }

    return false;
};

export const closeWebview = () => {
    const { webkit, nativeIntegration } = window;

    if (nativeIntegration?.closeView) {
        nativeIntegration.closeView();
    }

    if (webkit?.messageHandlers?.closeView?.postMessage) {
        webkit.messageHandlers.closeView.postMessage(null);
    }
};

if (isClient) {
    if (!window.nativeIntegration) {
        window.nativeIntegration = {
            onBackPressed: closeWebview,
        };
    }
}
